import React, { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { v1 as uuidv1 } from 'uuid'

interface IPrivateRoute {
    path?: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component: any,
    exact?: boolean,
    title: string,
}

const defaultProps = {
    path: '',
    title: '',
    exact: false,
    productIds: [],
}

const PrivateRoute = ({
    component: Component,
    title,
    ...otherProps
}
    : IPrivateRoute) => {
    const location = useLocation()

    useEffect(() => {
        document.title = `${process.env.REACT_APP_TITLE} - ${title}`
    }, [location])

    const memoizedComponent = useMemo(() => {
        return <Component key={uuidv1()} title={title} {...otherProps} />
    }, [location])

    return memoizedComponent
}
PrivateRoute.defaultProps = defaultProps

export default PrivateRoute